import { overrideCategory } from './categoryHelpers';
import { isGeneralNewInSale } from './conditionsHelpers';
import Departments from '../../../common/models/Departments';

const productList = {
  description: ({ brandName, categoryName: c, department: d, currentSeasonFull, urlQueryParams }) => {
    const brandWithSpace = brandName ? `${brandName} ` : '';
    const department = Departments.getName(d);
    const overriddenCategory = overrideCategory(d, c);

    if (isGeneralNewInSale({ categoryName: c, urlQueryParams })) {
      return `Shop the latest selection from the best global designer brands at italist and save up to 40% Express shipping on over 1000 brands for ${department.toLowerCase()}`;
    }

    return `Shop the ${currentSeasonFull} collection in ${brandWithSpace}${overriddenCategory.toLowerCase()} for ${department.toLowerCase()}. EXPRESS international shipping!`;
  },
  title: ({ categoryName: c, department: d, brandName, urlQueryParams }) => {
    const departmentPossessiveNoun = Departments.getNameAsPossessiveNoun(d);
    const overriddenCategory = overrideCategory(d, c);

    if (isGeneralNewInSale({ categoryName: c, urlQueryParams })) {
      return `${departmentPossessiveNoun} Luxury Fashion | italist, ALWAYS LIKE A SALE`;
    }

    return `${brandName || departmentPossessiveNoun} ${overriddenCategory} | italist, ALWAYS LIKE A SALE`;
  },
};

export default productList;
